import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsEditRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-edit',
	path: '(/secure/|/)project/EditProject([!%]?[\\w]*).jspa',
	query: ['pid'],
};
